<div class="right-panel h-100">
  <div class="right-side position-relative">
    <as-split direction="horizontal">
      <as-split-area [size]="detailsViewOpen ? 20 : 100">
        <div class="app-list" [ngStyle]="{
             'border-bottom':
             filteredApplications?.length > 0 ? '1px solid var(--s-border-color)' : 'none'
          }">
          <div class="actionBar">
            <div class="flex-grow-1">
              <input class="search" type="text" placeholder="Search by Name" [(ngModel)]="filterText"
                     (ngModelChange)="onSearch()" />
            </div>
            <button type="button" class="actionBtn" title="Refresh" (click)="refreshComponent()"
                    triggers="hover" ngbTooltip="Refresh Details">
              <span class="bi bi-arrow-clockwise"></span>
            </button>
            <ng-container *ngIf="(isGlobalAdmin || isReader) && !detailsViewOpen">
              <button class="actionBtn" style="border: 1px solid var(--s-primary-color); float: right"
                      (click)="downloadDataAsCsv()" triggers="hover" ngbTooltip="Download application data as CSV">
                <i class="bi bi-download"></i>
              </button>
              <button *ngIf="isMonitor == false" class="actionBtn"
                      style="border: 1px solid var(--s-primary-color); float: right" (click)="addApplication()"
                      triggers="hover" ngbTooltip="Add New Application">
                <span class="bi bi-disc"></span>
                <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
              </button>
            </ng-container>
          </div>

          <div class="listTable" *ngIf="filteredApplications?.length > 0">
            <!-- Table Container -->
            <div class="table-container">
              <table class="table table-hover table-condensed" [ngClass]="{'minW-90': detailsViewOpen}"
                     cellspacing="0" id="jobInfoListID" style="border-collapse: collapse"
                     dynamicPagination [rowHeight]="31" [offsetHeight]="180" [paginationInstance]="config">
                <thead>
                  <tr class="table-list-head synchpc-th">
                    <th scope="col"><a>#</a></th>
                    <th [resizable] scope="col">
                      <a>Name</a>
                      <span style="cursor: pointer" [ngClass]="
                          sortName == 0
                            ? 'bi-arrow-down-short'
                            : 'bi-arrow-up-short'
                        " class="bi" (click)="sortByName()"></span>
                    </th>
                    <th [resizable] scope="col"><a>Versions</a></th>
                    <th [resizable] scope="col">
                      Date Added<span style="cursor: pointer" (click)="sortByTime()" title="Sort Ascending/Descending"
                                      [ngClass]="
                          timeSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        " class="bi"></span>
                    </th>
                    <th scope="col" resizable>Type</th>
                    <ng-container *ngIf="isGlobalAdmin">
                      <th [resizable] scope="col">
                        <a>License Check</a>
                        <span style="cursor: pointer" [ngClass]="
                            sortLicense == 0
                              ? 'bi-arrow-down-short'
                              : 'bi-arrow-up-short'
                          " class="bi" (click)="sortByLicenseCheck()"></span>
                      </th>
                      <th scope="col" resizable>NodeGroup</th>
                      <th [resizable] style="width: min-content;" scope="col"></th>
                      <th scope="col" style="width: min-content;"></th>
                    </ng-container>
                    <th scope="col" style="width: min-content;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-list-row" style="cursor: pointer" [ngClass]="{
                      highlightClickedRow: application == selectedGroupedApplication
                    }" *ngFor="
                      let application of filteredApplications
                        | paginate : { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage };
                      let i = index
                    " (click)="redirectTo(application, i)" (dblclick)="toggleView(application)">
                    <td style="cursor: pointer" scope="row">
                      {{ config.currentPage == 1 ? i + 1 : (config.currentPage - 1) * config.itemsPerPage + (i + 1) }}
                    </td>
                    <td class="impListName" (click)="toggleView(application)">{{ application.appName }}</td>
                    <td>
                      <ng-container *ngIf="application.versions.length > 1; else singleVersion">
                        <select class="form-select" (change)="onSelectionChange($event)">
                          <option value="{{ ver }}" *ngFor="let ver of application.versions"
                                  [selected]="application.selectedVersion == ver ? true : false">
                            {{ ver }}
                          </option>
                        </select>
                      </ng-container>
                      <ng-template #singleVersion>
                        {{ application.versions[0] }}
                      </ng-template>
                    </td>
                    <td>{{ application.dateAdded }}</td>
                    <td>
                      {{ getKeyByValue(application.applicationType) || "NA" }}
                    </td>
                    <ng-container *ngIf="isGlobalAdmin">
                      <td>{{ application.checkLicense | boolToString }}</td>
                      <td>{{ application.applicationNodeGroups || "NA" }}</td>

                      <td class="text-center">
                        <div class="d-inline-block" style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          " *ngIf="
                            (application.errorChips &&
                            application.errorChips.length == 0) || application.applicationType == 2
                          ">
                          <p container="body" class="actionRequired" style="margin: 0">
                            No Pending Actions
                          </p>
                        </div>
                        <div class="d-inline-block" ngbDropdown container="body" placement="bottom" #myDrop="ngbDropdown"
                             *ngIf="
                             application.errorChips &&
                             application.errorChips.length > 0 && application.applicationType != 2
                          ">
                          <button class="actionRequired" id="dropdownManual" ngbDropdownToggle>
                            {{ application.errorChips.length }} Actions pending
                          </button>
                          <div ngbDropdownMenu aria-labelledby="dropdownManual"
                               style="padding: 0.5rem !important; min-width: fit-content">
                            <p container="body" triggers="hover" [ngbTooltip]="chip.tooltip" class="errorChip"
                               *ngFor="let chip of application.errorChips">
                              {{ chip.value }}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button *ngIf="isGlobalAdmin" type="button" class="editFileBtn" (click)="manageFiles(application)">
                          Manage Files
                        </button>
                      </td>
                    </ng-container>
                    <td>
                      <button *ngIf="application.isApplicationSessionReady" type="button" class="editFileBtn"
                              (click)="accessApp(application)">
                        Access
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination-container" *ngIf="filteredApplications.length > config.itemsPerPage">
              <pagination-controls class="my-pagination"
                                   (pageChange)="config.currentPage = $event"
                                   autoHide="true"
                                   (pageBoundsCorrection)="config.currentPage = $event">
              </pagination-controls>
            </div>
          </div>
          <div class="emptyAppError" *ngIf="filteredApplications?.length == 0 && !available">
            <p>{{ errorMsg }}</p>
          </div>
          <div class="emptyAppError" *ngIf="filteredApplications?.length == 0 && available">
            <p>No search results.</p>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="detailsViewOpen ? 80 : 0" *ngIf="detailsViewOpen" [minSize]="60">
        <div class="h-100 mx-1 px-1 advanceDetails">
          <app-application-advance-view (hideDetails)="hideDetails()"
                                        (handleAction)="handleAction($event)"></app-application-advance-view>
        </div>
      </as-split-area>
    </as-split>
    <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
                 [fullScreen]="false" name="applicationLoad">
      <p>Please wait ...</p>
    </ngx-spinner>
  </div>
</div>
